import { Checkbox, DataSource, HorizontalSpacer, Layout, SearchPanel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutSettlementLeaveHistoryList extends Layout {
    checkboxIsProcessed: Checkbox;
    checkboxIsVoidSearch: Checkbox;
    horizontalspacerSearch: HorizontalSpacer;
    searchpanelLeave: SearchPanel;
    sourceLeaveTransaction: DataSource;
    tableLeaveTransactions: Table;
    textboxAmountSearch: Textbox;
    textboxAppliesToSearch: Textbox;
    textboxBatchCode: Textbox;
    textboxBatchNumber: Textbox;
    textboxCheckDateSearch: Textbox;
    textboxCheckNumberSearch: Textbox;
    textboxEffectSearch: Textbox;
    textboxIdSearch: Textbox;
    textboxPayeeIdSearch: Textbox;
    textboxTrxDateSearch: Textbox;
}
